import React, { memo, FC, useCallback, useEffect, useRef } from 'react';

import { IWebdoorItem } from './interfaces';

import './styles.scss';

// Webdoor item
const WebdoorItem: FC<IWebdoorItem> = ({
  active,
  dir,
  drag,
  item,
  factoryLink,
  last,
}) => {
  const imageRef = useRef<HTMLImageElement>(null);

  // on drag
  const onDrag = useCallback(() => {
    if (typeof drag === 'function') return drag();

    return {};
  }, [ drag ]);

  // --- ANIMATIONS: restart image zoom-out every time this item becomes active ---
  useEffect(() => {
    const image = imageRef.current;
    if (!image) return;

    if (!active) {
      image.classList.remove('is-zooming');
      return;
    }

    image.classList.remove('is-zooming');
    // Force reflow so the browser treats the next animation as a new run.
    void image.offsetWidth;
    image.classList.add('is-zooming');
  }, [ active ]);
  // --- /ANIMATIONS ---

  // render
  return (
    <div
      className="webdoor-item"
      {...onDrag()}
      data-active={active}
      data-last={last}
      data-dir={dir}>
        <div className="link">
          <img
            ref={imageRef}
            src={item?.image.original.src}
            alt="webdoor" />
        </div>
    </div>
  );
};

export default memo(WebdoorItem);